// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils_Json$LiveRoom from "../Utils/Utils_Json.bs.js";

function graphQLerrorDecoder(json) {
  var decodedJs = Js_json.decodeObject(json);
  if (decodedJs === undefined) {
    return {
            message: "GraphQL error: Unable to decode error",
            locations: /* [] */0,
            extensions: {
              code: undefined,
              messageUser: undefined,
              type_: ""
            }
          };
  }
  var js_dict = Caml_option.valFromOption(decodedJs);
  var locations = Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(js_dict, "locations"), Js_json.decodeArray), /* [] */0, (function (x) {
          return Belt_List.fromArray(Belt_Array.keepMap(x, (function (json) {
                            return {
                                    column: Utils_Json$LiveRoom.Decode.toOptionInt(json, "column"),
                                    line: Utils_Json$LiveRoom.Decode.toOptionInt(json, "line")
                                  };
                          })));
        }));
  var extensions = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(js_dict, "extensions"), (function (x) {
              return {
                      code: Utils_Json$LiveRoom.Decode.toOptionInt(x, "code"),
                      messageUser: Utils_Json$LiveRoom.Decode.toOptionString(x, "messageUser"),
                      type_: Belt_Option.getWithDefault(Utils_Json$LiveRoom.Decode.toOptionString(x, "type"), "")
                    };
            })), {
        code: undefined,
        messageUser: undefined,
        type_: ""
      });
  return {
          message: Belt_Option.getWithDefault(Utils_Json$LiveRoom.Decode.toOptionString(json, "message"), "GraphQL error: Unable to decode error"),
          locations: locations,
          extensions: extensions
        };
}

var Errors = {
  graphQLerrorDecoder: graphQLerrorDecoder
};

export {
  Errors ,
}
/* No side effect */
